'use client';

import {
  STORE_ITEM_LOGIN_PROVIDER,
  STORE_ITEM_REFRESH_TOKEN,
  STORE_ITEM_SESSION_ID,
} from '@wwe-portal/web/utils/constants/keys';
import { safeSetLocalStorage } from '@wwe-portal/web/libs/storage/safe-local-storage';

/**
 * Save Session token action.
 * @param token {string}
 */
export const saveSessionToken = (token: string) => {
  // Auth-critical: safeSetLocalStorage's default recovery frees the cosmetic
  // blobs on a full store and retries, so quota can't break login persistence.
  safeSetLocalStorage(STORE_ITEM_SESSION_ID, () => token);
};

/**
 * Get Session token action.
 */
export const getSessionToken = () => {
  return localStorage.getItem(STORE_ITEM_SESSION_ID) || '';
};

/**
 * Remove Session token action.
 */
export const removeSessionToken = () => {
  localStorage.removeItem(STORE_ITEM_SESSION_ID);
};

/**
 * Get Refresh token action.
 */
export const getRefreshToken = () => {
  return localStorage.getItem(STORE_ITEM_REFRESH_TOKEN) || '';
};

/**
 * Save Refresh token action.
 * @param token {string}
 */
export const saveRefreshToken = (token: string) => {
  safeSetLocalStorage(STORE_ITEM_REFRESH_TOKEN, () => token);
};

/**
 * Remove Refresh token action.
 */
export const removeRefreshToken = () => {
  localStorage.removeItem(STORE_ITEM_REFRESH_TOKEN);
};

export const getLoginProvider = () => {
  return localStorage.getItem(STORE_ITEM_LOGIN_PROVIDER);
};

export const setLoginProvider = (value: string) => {
  safeSetLocalStorage(STORE_ITEM_LOGIN_PROVIDER, () => value);
};

export const clearLoginProvider = () => {
  localStorage.removeItem(STORE_ITEM_LOGIN_PROVIDER);
};
